export default __webpack_public_path__ + "static/media/edit-icon.66689323.svg";